var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.viewbox}},_vm._l((_vm.paths),function(item,index){return _c('path',{key:index,attrs:{"d":item.path,"fill":_vm.fill}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }